<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('ITEM.CREATE') }} {{ $t('ORDERS.ITEM') }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.go(-1)">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-card class="mt-3" :loading="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <order-customer-form
              v-if="isLoadedOrder"
              v-model="order"
              :person="person"
              :errors="errors.getAll()"
              :action="action"
              @valid="valid = $event"
              @update-prop="clearErrorByName($event)"
            ></order-customer-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              large
              class="float-right"
              color="success"
              :disabled="!valid"
              @click="submit"
              >{{ $t('BUTTON.SAVE') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import order from '../../mixins/order';
import OrderCustomerForm from './../../../components/forms/OrderCustomerForm.vue';
import { mapActions, mapGetters } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import { get } from 'lodash';
import { REPETITIVE_CUSTOMER } from '@/modules/orders/common/order-types';
import { CREATE, SHOW } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'CustomerOrderCreatePage',

  components: {
    OrderCustomerForm
  },

  mixins: [errors, order],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    person: {},
    valid: false,
    action: CREATE
  }),

  computed: {
    ...mapGetters(['loading'])
  },

  mounted() {
    this.$vuetify.goTo(0);
    this.retrievePerson(this.personId).then(({ data }) => {
      this.person = {
        id: get(data, 'id', ''),
        category: get(data, 'user.roles', []).map(role => role.title),
        mobile_phone: get(data, 'personal_profile.mobile_phone', ''),
        phone: get(data, 'personal_profile.phone', ''),
        email: get(data, 'user.email', ''),
        first_name: get(data, 'first_name', ''),
        last_name: get(data, 'last_name', ''),
        inhabitant: get(data, 'inhabitant', {}) || {}
      };

      this.order = {
        is_tender: false,
        street: get(
          data,
          'inhabitant.apartment.building.street',
          get(data, 'personal_profile.street', '')
        ),
        zip: get(
          data,
          'inhabitant.apartment.building.building_complex.zip',
          get(data, 'personal_profile.zip', '')
        ),
        city: get(
          data,
          'inhabitant.apartment.building.building_complex.city',
          get(data, 'personal_profile.city', '')
        ),
        apartment: get(data, 'inhabitant.apartment.name', ''),
        floor: get(data, 'inhabitant.apartment.floor', ''),
        type_id: REPETITIVE_CUSTOMER
      };
    });
  },

  methods: {
    ...mapActions('order', ['storeOrderRC']),
    ...mapActions('person', ['retrievePerson']),
    submit() {
      const order = {
        ...this.order,
        person_id: this.personId
      };

      this.storeOrderRC({ personId: this.personId, order })
        .then(() => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$router.go(-1);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
